export default {
    RATEHUB: 'ratehub',
    RH_INSURANCE: 'rhinsurance',
    CANWISE: 'canwise',
};
